import {
  IAdminOrganizationCreateNewPayload,
  IAdminOrganizationFormValues,
} from '@interfaces/adminOrganizations';

export const convertFormValuesToCreateNewPayload = (
  values: IAdminOrganizationFormValues,
): IAdminOrganizationCreateNewPayload => ({
  programCodeId: values.programCodeId,
  accessCode: values.accessCode,
  usesSports: values.usesSports,
  usesAthleteRoles: values.usesAthleteRoles,
  usesGender: values.usesGender,
  name: values.name,
  medicationExceptionFileName: values.medicationExceptionFileName,
  medicationExceptionFileUrl: values.medicationExceptionFileUrl,
  showMedicationExceptionLink: values.showMedicationExceptionLink,
});

export const validateForm = (values: IAdminOrganizationFormValues) => {
  const errors: Partial<Record<keyof IAdminOrganizationFormValues, string | boolean>> = {};

  if (!values.programCodeId) errors.programCodeId = true;
  if (!values.name) errors.name = true;
  if (!values.accessCode) errors.accessCode = true;
  if (values.showMedicationExceptionLink) {
    if (!values.medicationExceptionFileName) errors.medicationExceptionFileName = true;
    if (!values.medicationExceptionFileUrl) errors.medicationExceptionFileUrl = true;
  }

  return errors;
};
